import Configuration from "../configuration";

export default {
    endpoint: (segments) => Configuration.isDebug? `https://localhost:7116/api${segments}`:`https://burhan.idevapp.ru/api${segments}`
}